/* eslint-disable import/first */

/* eslint no-global-assign: 0, no-new: 0, no-undef: 0, global-require: 0 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { EventsPlugin } from '@jumpcloud/ui-events-vue';
import { XhrConsts } from 'client/util/Constants';
import EventOptions from 'client/GrowthEngineering/EventPluginOptions';
import FeatureFlagMixin from 'client/util/FeatureFlagMixin';
import MspState from 'client/components/models/MspState';
import PortalVue from 'portal-vue';
import TestIdMixin from 'client/util/TestIdMixin';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueHotkey from 'v-hotkey';
import VueRouter from 'vue-router';
import VueScroll from 'vue-scroll';

import 'normalize.css';

import '../scss/bootstrap-reset.scss';
import '../scss/jumpcloud.scss';

window._ = require('underscore'); // Change to lodash in phase3

// Don't require jQuery if already defined as any registered plugins will be lost!
if (!window.jQuery && !window.$) {
  window.$ = require('jquery');
  window.jQuery = require('jquery');
}

window.Backbone = require('backbone');
window.moment = require('moment');

window.Backbone.$ = $;

/**
 * Bootstrap is imported for a combination of Bootstrap-vue
 * and Backbone views that just assume it is globally available.
 * MC 6/26/19
 */
import '../node_modules/bootstrap/dist/js/bootstrap';
import util from 'client/util/index';

Vue.config.performance = process.env.NODE_ENV !== 'production';

Vue.use(PortalVue);
Vue.use(VeeValidate, { errorBagName: 'v2Errors', fieldsBagName: 'v2Fields' });
Vue.use(VueHotkey);
Vue.use(VueRouter);
Vue.use(VueScroll);
Vue.mixin(FeatureFlagMixin);
Vue.mixin(TestIdMixin);
Vue.use(EventsPlugin, EventOptions);

// For new Vue components

/**
 * Set orgId in the MspState if a multi-tenant admin user has navigated to
 * the admin portal to administer one of their managed organizations.
 *
 * Note that this method _must_ be executed before the Viewport is included
 * because doing so causes client/util/backbone-util.js to be included which
 * runs the one time jQuery.ajaxSetup() method.
 */

// @todo This might not be necessary here because it's done elsewhere,
// but it doesn't hurt anything so I'm leaving it for now.
function setOrgId() {
  const orgId = util.getUrlParameter(XhrConsts.xOrgIdKey);

  if (orgId) {
    MspState.orgId = orgId;
  }
}

setOrgId();

// Initialize settings and navigate admin to either admin portal or MTP view
const InitializationHandler = require('client/util/InitializationHandler').default;

(async () => {
  await InitializationHandler.initializeSettingsAndSetMspState();
  if (MspState.displayMtpView) {
    InitializationHandler.initializeMtp();
    return;
  }

  InitializationHandler.renderDualApps();
})();
